module.exports = __webpack_public_path__ + "img/dkjy_img.0057c607.png";